import { render, staticRenderFns } from "./black_list.vue?vue&type=template&id=dd82be00&scoped=true"
import script from "./black_list.vue?vue&type=script&lang=js"
export * from "./black_list.vue?vue&type=script&lang=js"
import style0 from "./black_list.vue?vue&type=style&index=0&id=dd82be00&prod&lang=scss&scoped=true"
import style1 from "./black_list.vue?vue&type=style&index=1&id=dd82be00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd82be00",
  null
  
)

export default component.exports